import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgClass } from '@angular/common';
import { DatePipe } from '@angular/common';

import { DashboardService } from 'src/app/modules/home/dashboard-widgets/services/dashboard.service';

import { TranslationModule } from 'src/app/modules/i18n';
import { GetUserTermsAndConditionLogsByCustomerC3IdAndEmail } from 'src/app/modules/home/dashboard-widgets/models/dashboard.model';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { C3DatePipe } from 'src/app/shared/pipes/dateTimeFilter.pipe';


@Component({
  selector: 'app-terms-and-conditions-accepted-list-customer',
  standalone: true,
  imports: [NgApexchartsModule,
    NgClass,
    TranslationModule
  ],
  templateUrl: './terms-and-conditions-accepted-list-customer.component.html',
  styleUrl: './terms-and-conditions-accepted-list-customer.component.scss',
  providers: [DatePipe]
})
export class TermsAndConditionsAcceptedListCustomerComponent implements OnInit {
  userTermsAndConditionLogs:Partial<GetUserTermsAndConditionLogsByCustomerC3IdAndEmail> [];
  showTermsAndConditionsAcceptanceLog = false;
  isGridDataLoading = false;

  constructor(private dashboardWidgetsService: DashboardService,
    private datePipe: DatePipe,
    private appSettingsService:AppSettingsService
  ) {}

  ngOnInit(): void {
    this.getUserTermsAndConditionLogs();
  }

  getUserTermsAndConditionLogs(): void {
    this.isGridDataLoading = true;

    this.dashboardWidgetsService.getUserTermsAndConditionLogs().subscribe(
      (response ) => {
        this.userTermsAndConditionLogs = response.Data;
        if (this.userTermsAndConditionLogs ) {
          this.showTermsAndConditionsAcceptanceLog = this.userTermsAndConditionLogs[0].ShowTermsAndConditionsAcceptanceLog;
        }
        this.isGridDataLoading = false;
      },
      error => {
        console.error('Error fetching data:', error);
        this.isGridDataLoading = false;
      }
    );
  }

  formatDate(date: Date): string {
    var datePipe = new C3DatePipe(this.appSettingsService);
              return datePipe.transform(date);
  }
}
